
import { Component, Prop, Vue } from 'vue-property-decorator';
import { UserProjectDocument } from "@/interfaces/user.project.interfaces";

@Component
export default class SAccContributorsBlock extends Vue {
  // Les props
  @Prop() private target!: boolean
  @Prop() private users!: UserProjectDocument[]
  @Prop() private height!: number

  // Les propriétés
  private search: string = ''

  // Les propriétés calculées
  private get theme() {
    return this.$store.state.theme
  }

  private get filteredUsers() {
    if (this.search && this.search.length) {
      return this.users.filter(up => `${up.user.firstname} ${up.user.lastname}`.toLowerCase().search(this.search.toLowerCase()) !== -1)
    } else {
      return this.users
    }
  }


  // Les hooks
  // Les méthodes surveillées
  // Les méthodes d'instance
  private async onClick(up: UserProjectDocument) {
    if (this.target) {
      this.$emit('dissociate', up)
    } else {
      this.$emit('associate', up)
    }
  }

  // Les méthodes statiques
  private icon = (item: UserProjectDocument) => {
    const lettre = item.user.capacity.substring(0, 1)
    return `mdi-alpha-${lettre}-circle`
  }

}
